import * as React from 'react';
import { Box, Paper, useTheme } from '@mui/material';
import { HeaderContent } from '../../types/reports';
import ReportHeader from './ReportHeader';

interface Props {
  headerContent?: HeaderContent;
  isLoading?: boolean;
  contentBoxStyle?: React.CSSProperties;
  children: React.ReactNode;
}

export default function ReportBox({
  headerContent,
  isLoading = false,
  contentBoxStyle = {},
  children,
}: Props) {
  const theme = useTheme();

  return (
    <Paper
      elevation={3}
      sx={{
        width: '100%',
        border: `1px solid ${theme.palette.darkerLightGrey.main}`,
      }}>
      <ReportHeader headerContent={headerContent} isLoading={isLoading} />
      <Box
        sx={{
          width: '100%',
          justifyContent: 'start',
          ...contentBoxStyle,
        }}>
        {children}
      </Box>
    </Paper>
  );
}
